import React, { useState } from "react";
import { Field } from "formik";
import Popup from "../popup/Popup";
import { POPUP_FORM_CONTENT_CLASS, ACTION_POPUP_CONTENT_INNER_CLASS } from "../popup/popupLayoutSpec";
import { AccountPopupField, AccountPopupSaveFooter } from "./accountPopupFields";

const AboutBusinessPopup = ({ isOpen, onClose, setFieldValue, values, errors, initialStep = 0 }) => {
  const [currentStep] = useState(initialStep);

  const displayValues = {
    businessBio: values.businessBio || "",
  };

  const steps = [
    {
      title: "Business bio",
      description: "Tell customers about your business",
      field: "businessBio",
      type: "textarea",
      placeholder: "Professional plumbing services with 25+ years of experience...",
      rows: 4,
    },
  ];

  const currentStepData = steps[currentStep];

  if (!isOpen) return null;

  return (
    <Popup
      setTrigger={() => {}}
      ShowCrossButton={true}
      cross={true}
      onClose={onClose}
      businessDashboard={true}
      hideLogoInHeader={true}
    >
      <div
        className="overflow-auto relative flex items-center justify-center"
        style={{ minHeight: "calc(100vh - 120px)" }}
      >
        <div className={POPUP_FORM_CONTENT_CLASS}>
          <div className={ACTION_POPUP_CONTENT_INNER_CLASS}>
            <form onSubmit={(e) => e.preventDefault()}>
              <Field name={currentStepData.field}>
                {({ form }) => (
                  <AccountPopupField
                    step={currentStepData}
                    fieldKey={currentStepData.field}
                    value={displayValues[currentStepData.field]}
                    onChange={(v) => setFieldValue(currentStepData.field, v)}
                    form={form}
                  />
                )}
              </Field>
              <AccountPopupSaveFooter onClick={onClose} />
            </form>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default AboutBusinessPopup;
